module.exports = __webpack_public_path__ + "static/img/ping_btn.f19f42b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ping_btn.png
// module id = +G4X
// module chunks = 1